import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Map as MapYandex, ObjectManager, YMaps } from 'react-yandex-maps';

const centrLatitude = '57.992105';
const centrlongitude = '56.204441';

const placemark = {
    office: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAA2CAYAAAC4PKvBAAAAAXNSR0IArs4c6QAABRVJREFUaAXtmc' +
        '9rJEUUx3uS0Z2s6GXFXU1y2ZuX3IQcQnLMQWXFo3+B4Em8+QMWNIIB8b+QHIJ40D8gIYeALAu5eNNDkl1j3Itismoy4/vU1Ld52zPTPT' +
        '1dLhPwwcurH6+qvu9br6o7Pa2sL61os16v11V5mmyr1ZpxeHptqwi0rOufqqLw9cCsKGhEZ6cK6pNgwCacmQdOmR2YVgEbGAPzAiq2ny' +
        'mifvTaq8Wmp1K/8cOPxXXARpqgeQQAv0qM5zlOEAJPeRolTxPA+VRJB3x2Npu58WIIvvvotyy7vExBhICDMz+clGkIjVSaCKCf//yroA' +
        'qgyXxx7BP4xHiCeW2KyPTMy69kKCKbkPkwb1LgYjoAj6kC892HD7I/Pnw/6/56EhZN8ScN8ALTBBAYhvEYQGrmkwAvMg1oGEZgXP0pmW' +
        '8GfATTAEQR2dTMc1L14Llm5ev2dvgLC0rKnpwzL93sM8phjOkRchngXIMmtJMmYp72cZgvPjnt7fCWTXdm+pfpxWSMVzANODGsAFIzPx' +
        'HjVUwDGoaRsAMxkDrMp2V8TKYJjDsdCWWzqZmvxfjYTBvoP7/cCMCf++Cj8Mivy3xaxgMU98feQXiojP1gif5hNxq+v9Q6nGw3zClXXQ' +
        'ihmPdbqgSmrRXmQ3A2tijy5+AqlYo+o+q1gPOWF9glf4cxpn5Wi/2lOxL9x94xF0U94G5gWVFM4lOXybJ5fV9a4PHW0Y3CQuFWgVlSJe' +
        '6CBzBpOSlw3d+6AgWKVAi3ytS9HQohjNvBRJUieoL6XZB7E5uUcQHxOa4nqPpS2WbAI8MCE1Ik3jj5TUFel/hpbF3bCLhyOj90AOQtsZ' +
        'DL4/rVAT8Z8Hj/DiwU2wPweIMUgwhjhvgNzFXRUOtdJZ8rMjvywAEsPinD4SR9hon8YpDe5b95V4mM+YVGlYcyPsq5Rjv//VxJubLAK3' +
        'N8Wraj+D/nlWX8f+BPO6X8Ayh87bdcum0grpvynYULuHJXDg8PP1lYWHjdfCvl6Ojo+8XFxU8rHe1V3nz4Ps13FL6n5L9GWDkHpUacNe' +
        'DCygzEjlL6u+vr61+cnZ39bOVSwQdfc/JrlM0tDMIlnIFR3SwwC8OeZS0AwKJqsu7p6elFu92+t7a29qbtmN9FG9aXbrf7eGNj473t7W' +
        '0+2QqQiCnOrXb8/jH9O1rqrNsDNApYFnzWlBTBUicY+oeJDxjf9s7Ozlurq6t3hznv7u7etcC+tT4WF4AAYpi/tcEu/fgCnJTBUr8UcA' +
        'CiAODXLSzBqN+KAyLg+BFoUMvhz+bn59/w3sfHx9/ZGfjY2lhYCqtVwAEv9mE+D1jAZJUuYlrtNmZABJwgtVOdpaWlF/b397+em5u7zY' +
        'jz8/OflpeX3zk4OPjdqo9NPXPjABfzPtCeWGUNRMnPhHLElqkWD4GcnJxcdjqd+ysrK3fsy+/F5ubmu1tbWw9sDpgGeBF82PqSNZhfas' +
        'X+75wshsj2a4N1tRctO4OSXp2oc2av7e3tvW02swC+MQPL56YCzrZ7MFYtFQj1Eg6nb6hTVrAA9+kCcIKgDYFRAAO8mCbW1GeQQh0hVZ' +
        'qIwPs51AajgCZFAIzCNGknBmWtqZ40BT5qNaWBgANeoOnTWRo1vrI9BXAxzGIChIVZgKP+KpuYZZsnF79o3jhBQfPosMoyldiXpa0xeC' +
        '3IZE1Fc2GlzOl3QXVsI9FijSZxg/18Knt2fdkNq1/U5PVHlo8ozpsMsJb9F9+0xaWKNxnqAAAAAElFTkSuQmCC',
    center: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAA2CAYAAAC4PKvBAAAAAXNSR0IArs4c6QAABTBJREFUaAXtmc' +
        '9rXFUUx990RjspWrWB1jSZTf+A7IQsQrLMQktFd25UshFcuHAXFAqagIEu+gcEdSNZRHGhf0BCFoFShPwBupj8cBpStUpSNTPj+dzMd7' +
        'h5nXk/5t2WCXjg5Jx377nnfu/3nnffm5dSdCqljo3a7XZL/jDZUql0wcPTrtiFQMt6/UPlCl8bzFoFjWh5qKCeBQM24Yx84PjswLAK2M' +
        'DomBdQsf1cHPVrH12JNz2T63t3H8bnARtlgnZXAPDzxHi3xlmEwOMPo3TLBHB+qQQDXi6Xo9EXrrnFH/7ViJrNZggiBByc3ZsTnwbXyE' +
        'URGX3xWrT03opT/EByBp8YD5JbTI+9UovGRmsuJz63U0DmXd6gwB3T765EY1dqkZiG+f2H9Wjh6/nowe97QQgiSRDgcaYBffio4UCOXr' +
        'ZSsU0OzXwQ4HGmD/9sRAtfzTvgS++vOPZDM18IeD+mKY393+oO+P6hWavx0Mxzp+rBc9H8S/Z2+KubsfMn6cl59eXr0ZJq2krCMf3lvK' +
        'tpbkaEY5GaF/OUUJaajz857e3wVUt3ZPq36clAjKcxDWj/HKfGQzM/EONpTKvmjRl3mrATeZkPynhWpq++dD0iFsHXOR6S+VyMZ2Ua0H' +
        'e+XXDAP357yT3yOcfzMB+UcYfE+8M7yIM/9px6zX1dxbOwou8vuW5Onc86JeII1c/OwDQC8zwxdcr4YxTPKdOr34+N+7mApzGmfmpZjC' +
        'btiOKJySu5gGdNLiaJz8tk1jmCAtepoxMFEJwqMMsCtAtZwSXFBQWu85sa94UaH8q3Q4EsXyhHgEbPvB1aAH0hJSjjAubXOO8oT0MKAa' +
        'eW3ZOxg0xPTJ0WNOMnxQ26qELAXU3bL5xm6/THMOVAW/yXTta4PIsYCDhA4+Acu512+rSYrHF5QBOb611FyXsde+rD6vjD563QPx5pky' +
        'gOG5en8q7CRFmfdlnj4sDTrvn1cy7l3AJPrfFh2Y74b85zy/j/wJ91SfkPIPe132rphoG4ZMp3Ft6MUnelXq9/OjEx8brFpsrOzs6PtV' +
        'rts9TAKOK/fxzwfEfhe4rDZ9aJQKmRYA04MZ+B2H5Kf2tubu6Lo6OjX8xPFGKItSB/jqTcwiBcwukY1cnCImDYZ1kTADCuStY6ODg4qV' +
        'Qq92dnZ2/ajvm7aMNOpdVqPV5cXPxwbW2NT1wCJGLiudVO3L+m/3Qs18zbBjQKWCZ83pQSwXLNYujvJf6Cia2sr6+/OTMzc7tX8MbGxm' +
        '1b2PfWx+QC4ED0irc22KWfWIBTMliumwIOQBQA/HcLy2LUb+4TIuDEsVCnVsOfj4+Pv+FH7+7u/mD3wCfWxsRSWE0DDnixD/PdBQuYrM' +
        'pFTKvdxjwhAs4itVPVycnJy1tbW9+MjIzcYMTx8fHPU1NT72xvbz+yy8emPnNZgIt5f6FtscociIqfhArEJqkmdwtpNBrNarX60/T09C' +
        '378nuyvLz8werq6p7lgGmAx8G7rU+Yg/xScx3Gbv0yqS/xa7/P99kZlPKqdnTE7MXNzc23zEa2gO/MwPKxqYCz7T4Yu0wUCPXF3Zx+Qx' +
        '5fiwO4Xy4AZxG0ITAKYIDHy8SaThnEySOUShEReD+H2mAU0JQIgFGYpuzEoKw15ZOiwPvNpjIQcMALNH26l/qNT20PAVwMM5kAYWEW4K' +
        'h/lA3MsuXpij9pt3EAR3l0s8qSSuzL0lYYvCYkWVFRLqyUnP4u6BpbSDRZoSTeYD+ffJ9d3/eG5XeVPP/I5BHxvMEAa9r/AHNo7oNx14' +
        'auAAAAAElFTkSuQmCC',
    dealer: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAA2CAYAAAC4PKvBAAAAAXNSR0IArs4c6QAABu9JREFUaAXtmd' +
        '9vFFUUx2e3q92tEVBBiqWa8Af0TcIDgUce1Gh8NCaGHw8o/gVEExJtoryjPCDqg4QHYnzQPwDCA2KMSf8AjZZiy6LyI2mLtruez535zp' +
        '7Ozu7MbispiSe5vXfOnHPu937vmTN3upUolkrSR+12u6XxZuorlUrV4WnX7EKg1bv7m2oofG0waxUoaSObCupaMGATzsgDZ8wObFYBGx' +
        'gD8wIqth/Lot721tdrVcHNVGyYiR4IMRBrh/ibiXvny9ezQcDGrGFmrQC3R4nxihhndQLPuLckTMugmmVezCUGvXakS5+Jq/iuF8lBJe' +
        'BMVw64i9RrWBupRM9uqYfb8/eWo5XVYlS9Yjm9gAdqBJz7Au9sc4bBzfTCUk0UbSmiaOfWenTu7b3B+din16O5P5eiVnK/WontQZEnss' +
        'u5twafB55jO5gKpseN6clnxqIXdowFZ8Zgnr+7tFHMh7jFwLMMd4gNAcQQTO7a1ojOHX8xen77WGAdg8/e2Rv9dnsxEvPBiT9J3FYSTz' +
        'ugHUntegyKgfdw9OraSDUa3zpqTDeM6ScM9Gg0f2c5mIxvq0dkh5i/tUE5Xww8YURVwANmDFO7DCg5HTM9Gi3cXY6OWm4j541xcr6L+c' +
        'zOBeMB/hQD7xMsm9MAhGlSY/aPxeD5a3Mx5PhGM18IXEwrB/06diXVQzkN04fPfB+A377/IJge/eR62InzJ9YyfySpNmFVZtlS0vsJ+o' +
        'wLgef5qk6remSZJo/HtzaCK2NyvCfzQ1abQuBZpqkiO6zkkbOeaXKaFGneexBXl6SOHzHGf7f0yTL/ufmHanP2h1Dno/QzQGUsj7KOrh' +
        'B4x9SOjlantz/ZqdN5TPPGfO6pRrDFlzF1PJ/5SqhE9vES3bI0W1lVYvpZ88flgRsRO620nTueYdoYhTle7aF6GNMs8OSFmTDjR29OhR' +
        'cPdTxUm2zOm33MfPyGTd/I+XhTbXngqUtnwBnk5l9LoZXhSvYsbL3nl/LAbbsXLFcPn4mrxBfvxmeR8OTZ01e17W6GqnI9mni6EcE0cv' +
        'KrmZDDpEpWQhVKdoxUabH6cik+2BdPEWO6TxURo9qRLGiuZY9N2RRRnPKMJx4cBnUgjFW8AjuvwaqVoeb9zpszMG0+6ZmEJ5WWCFUrVK' +
        '6kfMlO93v1AwPvFQh9qO/2UqKXUFVgdj5UjQ5g3R+2LwSuhy4hpHsesCR4qCqcWchxL5zHj51NqgZJTC4lAsM0xV+7m7Lq7guBd7v01o' +
        'zYrICm+dMhHtzbSCkELiZ6TcqO0Lyd6jU+nFH6CX7BN9m1h5Lj5DI5jDC53piqFugZezvSytthM4wUMp4GVV66ikBOc+ZYTWgiHdCR01' +
        '70Rs21I4OsiemyGVUeuEMCgCw4bkvPPYEsa+fClxqWBp5+W1pY5TCfbFElSc421LVDvpMet5M3JadCXx7TGm7UYscbEynLdDC2P6WBy4' +
        'He53Ba2pIUypbP8Fb0zko1IU3W7U3KjEsDD0++RcwCy06S2iWAdK0ziPxV+4Vf19l4va7TuL0MNquexAQ8zI9aG7ND/bz1m07sF4lxA8' +
        'UXOB+zK48s4/8Df9i55asKdaBtubTHev5jSc7zu0vhrszOzr6/e/ful8y2UG7cuPHd5OTkB4WGcQFbNTtymtwO+OQnUFJSrWg4rLiecV' +
        '7DrnXo0KGPFxcXf7FxX8EGWzPyc+TF9XOHORIf4QyMqrKwCBj2LGsCnLNNi2w1m82VWq3248GDB1+xHfO7aG6xtFqt5enp6ROXLl1aMI' +
        '2AEdOP/Rxa0D9m87c1enTMG97TAAcsEz5ujRSh55rFcD9P/IKxrV2+fPm1AwcOnMozvnLlyilb2Dd2T4C0cFjME/TYYA9wUoae61Umzw' +
        'Lg1y2AsBjdt2GXyA87Fhqa5fCHExMTL3vrubm5b+0ZeM90TKwGu4E9b+vGSgvtime8JWDqlS5iWnoXLx0KuN+p+tTU1JZr165daDQae7' +
        'BcWlr6ed++fW/MzMzcs0tOVJ65MsDFvF9oW6wyB6JVElCG9P2aJg8LWVhYWK3X6z/t37//VXsLr5w+ffr4xYsXb1oMmAZ4FnzY+j5zEF' +
        '/NhvGphskQ9fFV97X02Z6doZFe/MxG45No9OrVq+EXVlsAv/DCMl8XAs62ezB22Vcg1Et4OL1ikLEWC3CfLgBnAegQGAUwwLNpYqpBz4' +
        'W4xA9gPBrur8B7b+lgFNCkCIBpME3aiUH1phpMyPH/QpQGAg54geaenqWh594I4GIYEAJED7MAp/lSNjTLFicVP2mqHGKgOHpY1RNK7K' +
        'tHt27wmpBg6xXFolcjpt8FXdOvSzTZuoI4Zx9PY8+uHzu3wYcKPrhnf49s3A0DrGn/BRMxMxQZGn18AAAAAElFTkSuQmCC',
    wifi: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAA2CAYAAAC4PKvBAAAAAXNSR0IArs4c6QAABu9JREFUaAXtmd9v' +
        'FFUUx2e3q92tEVBBiqWa8Af0TcIDgUce1Gh8NCaGHw8o/gVEExJtoryjPCDqg4QHYnzQPwDCA2KMSf8AjZZiy6LyI2mLtruez535zp7O' +
        'zu7MbispiSe5vXfOnHPu937vmTN3upUolkrSR+12u6XxZuorlUrV4WnX7EKg1bv7m2oofG0waxUoaSObCupaMGATzsgDZ8wObFYBGxgD' +
        '8wIqth/Lot721tdrVcHNVGyYiR4IMRBrh/ibiXvny9ezQcDGrGFmrQC3R4nxihhndQLPuLckTMugmmVezCUGvXakS5+Jq/iuF8lBJeBM' +
        'Vw64i9RrWBupRM9uqYfb8/eWo5XVYlS9Yjm9gAdqBJz7Au9sc4bBzfTCUk0UbSmiaOfWenTu7b3B+din16O5P5eiVnK/WontQZEnssu5' +
        'twafB55jO5gKpseN6clnxqIXdowFZ8Zgnr+7tFHMh7jFwLMMd4gNAcQQTO7a1ojOHX8xen77WGAdg8/e2Rv9dnsxEvPBiT9J3FYSTzug' +
        'HUntegyKgfdw9OraSDUa3zpqTDeM6ScM9Gg0f2c5mIxvq0dkh5i/tUE5Xww8YURVwANmDFO7DCg5HTM9Gi3cXY6OWm4j541xcr6L+czO' +
        'BeMB/hQD7xMsm9MAhGlSY/aPxeD5a3Mx5PhGM18IXEwrB/06diXVQzkN04fPfB+A377/IJge/eR62InzJ9YyfySpNmFVZtlS0vsJ+owL' +
        'gef5qk6remSZJo/HtzaCK2NyvCfzQ1abQuBZpqkiO6zkkbOeaXKaFGneexBXl6SOHzHGf7f0yTL/ufmHanP2h1Dno/QzQGUsj7KOrhB4' +
        'x9SOjlantz/ZqdN5TPPGfO6pRrDFlzF1PJ/5SqhE9vES3bI0W1lVYvpZ88flgRsRO620nTueYdoYhTle7aF6GNMs8OSFmTDjR29OhRcP' +
        'dTxUm2zOm33MfPyGTd/I+XhTbXngqUtnwBnk5l9LoZXhSvYsbL3nl/LAbbsXLFcPn4mrxBfvxmeR8OTZ01e17W6GqnI9mni6EcE0cvKr' +
        'mZDDpEpWQhVKdoxUabH6cik+2BdPEWO6TxURo9qRLGiuZY9N2RRRnPKMJx4cBnUgjFW8AjuvwaqVoeb9zpszMG0+6ZmEJ5WWCFUrVK6k' +
        'fMlO93v1AwPvFQh9qO/2UqKXUFVgdj5UjQ5g3R+2LwSuhy4hpHsesCR4qCqcWchxL5zHj51NqgZJTC4lAsM0xV+7m7Lq7guBd7v01ozY' +
        'rICm+dMhHtzbSCkELiZ6TcqO0Lyd6jU+nFH6CX7BN9m1h5Lj5DI5jDC53piqFugZezvSytthM4wUMp4GVV66ikBOc+ZYTWgiHdCR0170' +
        'Rs21I4OsiemyGVUeuEMCgCw4bkvPPYEsa+fClxqWBp5+W1pY5TCfbFElSc421LVDvpMet5M3JadCXx7TGm7UYscbEynLdDC2P6WBy4He' +
        '53Ba2pIUypbP8Fb0zko1IU3W7U3KjEsDD0++RcwCy06S2iWAdK0ziPxV+4Vf19l4va7TuL0MNquexAQ8zI9aG7ND/bz1m07sF4lxA8UX' +
        'OB+zK48s4/8Df9i55asKdaBtubTHev5jSc7zu0vhrszOzr6/e/ful8y2UG7cuPHd5OTkB4WGcQFbNTtymtwO+OQnUFJSrWg4rLiecV7D' +
        'rnXo0KGPFxcXf7FxX8EGWzPyc+TF9XOHORIf4QyMqrKwCBj2LGsCnLNNi2w1m82VWq3248GDB1+xHfO7aG6xtFqt5enp6ROXLl1aMI2A' +
        'EdOP/Rxa0D9m87c1enTMG97TAAcsEz5ujRSh55rFcD9P/IKxrV2+fPm1AwcOnMozvnLlyilb2Dd2T4C0cFjME/TYYA9wUoae61UmzwLg' +
        '1y2AsBjdt2GXyA87Fhqa5fCHExMTL3vrubm5b+0ZeM90TKwGu4E9b+vGSgvtime8JWDqlS5iWnoXLx0KuN+p+tTU1JZr165daDQae7Bc' +
        'Wlr6ed++fW/MzMzcs0tOVJ65MsDFvF9oW6wyB6JVElCG9P2aJg8LWVhYWK3X6z/t37//VXsLr5w+ffr4xYsXb1oMmAZ4FnzY+j5zEF/N' +
        'hvGphskQ9fFV97X02Z6doZFe/MxG45No9OrVq+EXVlsAv/DCMl8XAs62ezB22Vcg1Et4OL1ikLEWC3CfLgBnAegQGAUwwLNpYqpBz4W4' +
        'xA9gPBrur8B7b+lgFNCkCIBpME3aiUH1phpMyPH/QpQGAg54geaenqWh594I4GIYEAJED7MAp/lSNjTLFicVP2mqHGKgOHpY1RNK7KtH' +
        't27wmpBg6xXFolcjpt8FXdOvSzTZuoI4Zx9PY8+uHzu3wYcKPrhnf49s3A0DrGn/BRMxMxQZGn18AAAAAElFTkSuQmCC',
};

const icons = {
    office: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABGdBTUEAALGPC/xhBQAAAH9JREFUKB' +
        'XFk8ENgCAMRcW4gIPoBDi9GziIjqApySO1FA7ERC7lf/p+eyGccbmHzjN2cglrwvN+NLOrMCDVS3FhgGtbE4O2AQVMIyAVXwe8YBosYD' +
        'UBGfZAgTy/gEnnAdDz6cmTMXS1oH6T+2QNNOuKroV8O1lP9LbAkxp++xgPdP02vyQ2MmQAAAAASUVORK5CYII=',
    center: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABGdBTUEAALGPC/xhBQAAAH9JREFUKB' +
        'XFk8ENgCAMRcU4gM4ji+kATuY+jqApySO1FA7ERC7lf/p+eyGs23wPnWfs5BLWhM/jamZXYUCql+LCAHFfEoO2AQVMIyAVXwe8YBosYD' +
        'UBGfZAgTy/gEnnAdDz6cmTMXS1oH6T+2QNNOuKroV8O1lP9LbAkxp++xgPcy83UuV2saYAAAAASUVORK5CYII=',
    dealer: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABGdBTUEAALGPC/xhBQAAAS9JREFUKB' +
        'V9k9FxwkAMRH03fDuUFejEST2ETkhbHheAs28lxTYfaMb4pNOuVgu0j+mxDkTTo9NTr07+LrJ36wuKoUOQZ/CQVfyfq7cuPJmkixZmxf' +
        'xzsYrnGt3bJAasustGJBMutmYguQmUO/Sq6V21XntS5IF9vn269/z96zcEjt065L0AgAzMxnF62MDz10bgqZKLJzy99kBuTWAisshpKo' +
        'IFD4ToTftqhcDqsNyvVkYjAICQLPeQXAReKT0IsJrHKeQNNiLy+SaClG1mfYyQS3+t6zoyIsSkYB8bVg7vvq7a9XRgABVYOZ4OqxSuB7' +
        'uNglxpkQBz2NE8v0qm7D01AOkn92FAysLR19ir4Efl6Xo3/hgH6Ul0qMEGOVpzLUpWwcdebl0woZq5dy58xR9WZ4PiQr81VgAAAABJRU5ErkJggg==',
};

export const prepareMapOptions = (contacts) => {
    if (!Array.isArray(contacts)) {
        return [];
    }

    return contacts.map(item => {
        const { pid, latitude, longitude, company, name, address, type, hours, hotspot_type } = item;
        const miscText = name ? name : company.name;
        return (
            {
                type: 'Feature',
                id: pid,
                geometry: {
                    type: 'Point',
                    coordinates: [latitude, longitude],
                },
                properties: {
                    balloonContent: `<div style="flex-direction: column;"><div style="font-weight: 700;">${miscText}</div><div>${address}</div><div>${hours}</div></div>`,
                    hintContent: address,
                },
                options: {
                    iconLayout: 'default#image',
                    iconImageHref: placemark[type],
                    iconImageSize: [23, 27],
                    iconImageOffset: [-11, -13],
                },
                address,
                contactType: type,
                misc: miscText,
                hours,
                category: hotspot_type,
            }
        );
    });
};

export class YandexMap extends PureComponent {
    static propTypes = {
        points: PropTypes.array,
        cityName: PropTypes.string,
    };

    static defaultProps = {
        points: [],
        cityName: '',
    };

    mapRef = React.createRef();
    managerRef = React.createRef();

    componentDidUpdate() {
        this._centerMap();
    }

    _onLoad = (ymaps) => {
        const instanceMap = this.mapRef?.current;
        instanceMap.behaviors.disable('scrollZoom');
        this._centerMap(ymaps);
    }

    _centerMap(ymaps) {
        const { points, cityName } = this.props;
        const instanceMap = this.mapRef?.current;

        if (points.length === 1) {
            instanceMap.setCenter(instanceMap.geoObjects.getBounds()[0]);
        } else if (points.length > 1) {
            setTimeout(()=>{
                instanceMap.setBounds(instanceMap.geoObjects.getBounds());
            }, 100);
        } else if (points.length === 0 && !!cityName) {
            const geocoder = ymaps.geocode(cityName);
            geocoder.then((res) => {
                const coords = res.geoObjects.get(0).geometry.getCoordinates();
                instanceMap.setCenter(coords);
            });
        }
    }

    openMapBalloon = (id) => {
        const { points } = this.props;

        const objectManager = this.managerRef?.current;
        const instanceMap = this.mapRef?.current;


        if (objectManager) {
            const curObject = points.find(elem => elem.id === id);
            if (curObject) {
                objectManager.objects.balloon.open(id, 'Feature');
            } else {
                const curObject = points.find(elem => elem.id === id);
                if (curObject) {
                    instanceMap.setCenter(curObject.geometry.coordinates);
                }
            }
        }
    }

    render() {
        const { points } = this.props;
        const centerCoords = points.length > 0 ? points[0].geometry.coordinates : null;

        return (
            <YMaps
                query={{ apikey: 'e33263b7-2f94-4cf2-89f2-2527353a4b43' }}
            >
                <MapYandex
                    instanceRef={this.mapRef}
                    state={{
                        center: centerCoords || [centrLatitude, centrlongitude],
                        zoom: 10,
                        controls: ['zoomControl'],
                    }}
                    modules={['control.ZoomControl', 'geocode']}
                    options={{ suppressMapOpenBlock: true }}
                    width='100%'
                    height='100%'
                >
                    <ObjectManager
                        instanceRef={this.managerRef}
                        onLoad={this._onLoad}
                        options={{
                            clusterize: true,
                            gridSize: 32,
                        }}
                        objects={{
                                iconLayout: 'default#image',
                                iconImageHref: icons.blue,
                                iconImageSize: [23, 27],
                                iconImageOffset: [-11, -13],
                            }}
                        clusters={{
                            preset: 'islands#greenClusterIcons',
                        }}
                        features={points}
                        modules={[
                            'objectManager.addon.objectsBalloon',
                            'objectManager.addon.objectsHint',
                        ]}
                    />
                </MapYandex>
            </YMaps>
        );
    }
}
